import React, { useEffect, useState } from "react";
import cover from "../assets/images/cover-img.png";
import avtar from "../assets/images/default_user.jpg";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "./features/authSlice";
import { fetchUserLocation } from "./features/locationSlice";
import AddressModal from "./AddressModal";
import { fetchUserDetails, deleteUser } from "./features/userDetailSlice";

const Profile = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchUserDetails());
    if (!locationData) {
      dispatch(fetchUserLocation());
    }
  }, []);

  const [values, setValues] = useState({
    userId: "",
    name_title: "Mr",
    full_name: "",
    mobile: "",
    email: "",
    gender: "",
    profilePicture: "",
    countryCode: "",
    street: "",
    postalCode: "",
    isMobileVerified: false,
  });
  const [imgFile, setImgFile] = useState();
  const [imageLoading, setImageLoading] = useState(false);
  const [clist, setClist] = useState([]);
  const [sclist, setSClist] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [userInfo, setUserInfo] = useState({
    name_title: "Mr",
    full_name: "",
    mobile: "",
    email: "",
    gender: "",
    profilePicture: "",
    countryCode: "",
    isMobileVerified: false,
  });

  const [addresses, setAddresses] = useState([]);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);

  const [previewImage, setPreviewImage] = useState(null);
  const [showImageActions, setShowImageActions] = useState(false);
  const { token, user } = useSelector((state) => state.auth);
  const locationData = useSelector((state) => state.location.locationData);

  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const { userDetail, loading: userDetailLoading } = useSelector(
    (state) => state.userDetail
  );

  useEffect(() => {
    if (userDetail) {
      const userData = {
        userId: userDetail._id,
        name_title: userDetail.name_title || "Mr",
        full_name: `${userDetail.firstName} ${userDetail.lastName}`,
        mobile: userDetail.mobile
          ? String(userDetail.mobile).replace(/^91/, "").replace(/\D/g, "")
          : "",
        email: userDetail.email.toLowerCase(),
        gender: userDetail.gender?.toLowerCase() || "",
        profilePicture: userDetail.profilePicture,
        countryCode: userDetail.countryCode || "+91",
        isMobileVerified: userDetail.isMobileVerified,
      };

      setUserInfo(userData);
      setValues(userData);
      setAddresses(userDetail.addresses || []);
    }
  }, [userDetail]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  // Add validation for mobile
  const validateMobile = (mobile) => {
    // Remove any non-digit characters and country code if present
    const cleanNumber = mobile.toString().replace(/\D/g, "");

    // If number starts with country code (e.g., 91 for India), remove it
    const numberWithoutCountry = cleanNumber.startsWith("91")
      ? cleanNumber.slice(2)
      : cleanNumber;

    // console.log("Cleaned mobile number:", numberWithoutCountry);

    // Check if the remaining number is valid (10 digits for India)
    return numberWithoutCountry && numberWithoutCountry.length >= 10;
  };

  const validateProfile = () => {
    const { full_name, mobile, email, gender } = values;
    const toastId = "profile-form";

    if (!full_name || !full_name.trim()) {
      if (!toast.isActive(toast)) {
        toast.error("Please Enter your full name", { toastId: toastId });
      }
      return false;
    }

    // Enhanced mobile validation
    if (!mobile || !validateMobile(mobile)) {
      if (!toast.isActive(toast)) {
        toast.error("Please enter a valid mobile number (minimum 10 digits)", {
          toastId: toastId,
        });
      }
      return false;
    }

    if (!email || !email?.trim()) {
      if (!toast.isActive(toast)) {
        toast.error("Please Enter Your Email", { toastId: toastId });
      }
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please Enter Valid Email Address");
      return false;
    }
    if (!gender || !gender?.trim()) {
      toast.error("Please Select Your Gender");
      return false;
    }
    return true;
  };

  // console.log(values)
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Prepare the data to be sent to the backend
    const updateData = {
      firstName: values.full_name.trim().split(" ")[0],
      lastName: values.full_name.trim().split(" ")[1] || "",
      name_title: values.name_title,
      mobile: values.mobile,
      email: values.email,
      countryCode: values.countryCode,
      gender: values.gender,
    };

    const formData = new FormData();

    // Append all fields except address
    Object.keys(updateData).forEach((key) => {
      formData.append(key, updateData[key]);
    });

    // Append profile picture if it exists
    if (imgFile) {
      formData.append("profilePicture", imgFile);
    }

    // console.log("user from redux ", user);
    formData.append("userId", user.id);

    if (validateProfile()) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/users/update-profile`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: formData,
          }
        );
        const data = await response.json();

        if (data.success) {
          toast.success(data.message);
          setShowImageActions(false);
          dispatch(fetchUserDetails()); // Refresh profile data
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        // console.log("profile update error ", error);
        toast.error("Failed to update profile");
      }
    }
  };

  const handleAccountDelete = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover your profile after deletion!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteUser(values.userId))
          .unwrap()
          .then(() => {
            toast.success("Account deleted successfully");
            dispatch(logout());
            navigate("/");
          })
          .catch((error) => {
            toast.error(error || "Failed to delete account");
          });
      }
    });
  };

  const handleImageChange = (e) => {
    setImageLoading(true);
    const file = e.target.files[0];
    setImgFile(file);

    if (!file) return;

    const validImageTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/jpg",
    ];

    if (!validImageTypes.includes(file.type)) {
      toast.error("Please upload only image files (JPG, PNG, GIF)");
      e.target.value = "";
      return;
    }

    // Create preview URL
    const previewUrl = URL.createObjectURL(file);
    setPreviewImage(previewUrl);
    setShowImageActions(true);

    setTimeout(() => {
      setImageLoading(false);
    }, 1000);
  };

  const handleCancelImage = () => {
    setImgFile(null);
    setPreviewImage(null);
    setShowImageActions(false);
    // Reset the file input value
    document.getElementById("profile").value = "";
  };

  useEffect(() => {
    if (clist.length > 0) {
      dispatch(fetchUserDetails());
    }
  }, [clist]);

  const handleAddressSubmit = async (addressData) => {
    try {
      const method = selectedAddress ? "PUT" : "POST";
      const url = selectedAddress
        ? `${process.env.REACT_APP_BACKEND_URL}/api/addresses/${selectedAddress._id}`
        : `${process.env.REACT_APP_BACKEND_URL}/api/addresses`;

      const res = await fetch(url, {
        method,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(addressData),
      });

      const data = await res.json();
      if (data.success) {
        toast.success(data.message);
        dispatch(fetchUserDetails());
        setShowAddressModal(false);
        setSelectedAddress(null);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      // console.log("address update error", error);
      toast.error("Failed to update address");
    }
  };

  const handleSetDefaultAddress = async (addressId) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication required");
        return;
      }

      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/addresses/${addressId}/set-default`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.json();
      if (data.success) {
        toast.success(data.message);
        dispatch(fetchUserDetails()); // Refresh the profile to get updated addresses
      } else {
        toast.error(data.message || "Failed to set default address");
      }
    } catch (error) {
      console.error("Set default address error:", error);
      toast.error("Failed to set default address");
    }
  };

  const handleDeleteAddress = async (addressId) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication required");
        return;
      }

      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/addresses/${addressId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.json();
      if (data.success) {
        toast.success(data.message);
        // Remove the address from local state
        setAddresses(addresses.filter((addr) => addr._id !== addressId));
        dispatch(fetchUserDetails()); // Refresh the profile to get updated addresses
      } else {
        toast.error(data.message || "Failed to delete address");
      }
    } catch (error) {
      console.error("Delete address error:", error);
      toast.error("Failed to delete address");
    }
  };

  // // Add function to handle mobile update from modal
  // const handleMobileUpdate = async (newMobile, countryCode) => {
  //   if (!validateMobile(newMobile)) {
  //     toast.error("Please enter a valid mobile number");
  //     return;
  //   }

  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BACKEND_URL}/api/users/${values.userId}`,
  //       {
  //         method: "POST",
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           mobile: newMobile,
  //           countryCode: countryCode,
  //         }),
  //       }
  //     );

  //     const data = await response.json();
  //     if (data.success) {
  //       toast.success("Mobile number updated successfully");
  //       dispatch(fetchUserDetails());
  //       return true;
  //     } else {
  //       toast.error(data.message);
  //       return false;
  //     }
  //   } catch (error) {
  //     console.error("Error updating mobile:", error);
  //     toast.error("Failed to update mobile number");
  //     return false;
  //   }
  // };

  const handleSendOtp = async () => {
    if (!values.mobile || !values.countryCode) {
      toast.error("Please enter a valid mobile number");
      return;
    }

    try {
      setLoading(true);

      // Format the phone number properly
      const phoneNumber = `${values.countryCode}${values.mobile}`;
      
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/send-otp`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            mobile: phoneNumber
          }),
        }
      );

      const data = await response.json();
      if (data.success) {
        setShowOtpInput(true);
        toast.success("OTP sent successfully");
      } else {
        toast.error(data.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      toast.error("Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp) {
      toast.error("Please enter OTP");
      return;
    }

    try {
      setLoading(true);

      const phoneNumber = `${values.countryCode}${values.mobile}`;

      // Verify the OTP
      const verifyResponse = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/verify-otp`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            mobile: phoneNumber,
            otp: otp
          }),
        }
      );

      const verifyData = await verifyResponse.json();
      
      if (!verifyData.success) {
        toast.error(verifyData.message || "Invalid OTP");
        return;
      }

      // Update mobile in database
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/update-mobile`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            mobile: values.mobile,
            countryCode: values.countryCode,
            isMobileVerified: true,
          }),
        }
      );

      const data = await response.json();
      if (data.success) {
        toast.success("Mobile number verified and updated successfully");
        setShowOtpInput(false);
        setOtp("");
        dispatch(fetchUserDetails()); // Refresh profile data
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      toast.error("Failed to verify OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="banner-innr">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-12 col-sm-12 mb-5">
              <div className="banner-innr-content">
                <h3>Profile</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="profile-sec tp-space">
        <div className="container">
          <div className="profile-innr mb-5">
            <form action="" onSubmit={handleSubmit}>
              <div className="profile-upload">
                <input
                  type="file"
                  onChange={handleImageChange}
                  accept="image/*"
                  id="profile"
                />
                {imageLoading && (
                  <span className="spinner-border spinner-border-sm lodo"></span>
                )}
                <div className="col-lg-12 mb-4 text-center position-relative">
                  <img
                    src={previewImage || values.profilePicture || avtar}
                    alt={values.full_name}
                    className="rounded-circle"
                    style={{ width: "150px", height: "150px" }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      display: "flex",
                      gap: "10px",
                      padding: "2px 5px",
                      borderRadius: "15px",
                    }}
                  >
                    <label
                      htmlFor="profile"
                      style={{
                        margin: "0",
                        cursor: "pointer",
                        marginRight: "-2px",
                      }}
                    >
                      <i className="fas fa-pen" />
                    </label>
                    {showImageActions && (
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        onClick={handleCancelImage}
                        style={{
                          color: "white",
                          backgroundColor: "red",
                          margin: "0",
                          padding: "0",
                          marginLeft: "55px",
                          fontSize: "16px",
                          width: "25px",
                        }}
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="profile-innr-frm">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="custom-frm-bx">
                      <label htmlFor="">Name</label>
                      <span className="text-danger"> *</span>
                      <div className="custom-frm-bx-innr">
                        <select
                          id=""
                          className="form-select border"
                          name="name_title"
                          onChange={handleChange}
                          value={values?.name_title}
                        >
                          <option value="Mr">Mr</option>
                          <option value="Mrs">Mrs</option>
                          <option value="Ms">Ms</option>
                        </select>
                        <input
                          type="text"
                          name="full_name"
                          value={values?.full_name}
                          onChange={handleChange}
                          className="form-control"
                          maxLength={50}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="custom-frm-bx">
                      <label htmlFor="">Mobile Number</label>
                      <span className="text-danger"> *</span>
                      <div
                        className="custom-frm-bx-innr"
                        style={{
                          border: "1px solid #dee2e6",
                          borderRadius: "5px",
                        }}
                      >
                        <PhoneInput
                          value={values.countryCode + values.mobile}
                          onChange={(phone, data) => {
                            // Extract the phone number without country code
                            const phoneWithoutCountry = phone.slice(
                              data.dialCode.length
                            );

                            // Only update if the new phone number is empty or contains only digits
                            if (
                              phoneWithoutCountry === "" ||
                              /^\d*$/.test(phoneWithoutCountry)
                            ) {
                              setValues((prev) => ({
                                ...prev,
                                mobile: phoneWithoutCountry,
                                countryCode: `+${data.dialCode}`,
                              }));
                            }
                          }}
                          inputClass="form-control"
                          containerClass="phone-input-container"
                          specialLabel=""
                          inputProps={{
                            required: true,
                            readOnly: values.isMobileVerified,
                          }}
                        />
                        {values.isMobileVerified ? (
                          <div className="verified-badge m-2">
                            <span className="badge bg-success">
                              <i className="fas fa-check-circle me-1"></i>
                              Verified
                            </span>
                          </div>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary m-2"
                            onClick={handleSendOtp}
                            disabled={loading}
                          >
                            {loading ? "Sending..." : "Verify"}
                          </button>
                        )}
                      </div>

                      {showOtpInput && !values.isMobileVerified && (
                        <div className="mt-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter OTP"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                          />
                          <button
                            type="button"
                            className="btn btn-success mt-2"
                            onClick={handleVerifyOtp}
                            disabled={loading}
                          >
                            {loading ? "Verifying..." : "Verify OTP"}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="custom-frm-bx">
                      <label htmlFor="">Email Address</label>
                      <span className="text-danger"> *</span>
                      <input
                        type="email"
                        name="email"
                        readOnly
                        value={values.email}
                        className="form-control"
                        maxLength={50}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="custom-frm-bx">
                      <label htmlFor="">Gender</label>
                      <span className="text-danger"> *</span>
                      <select
                        name="gender"
                        value={values?.gender}
                        onChange={handleChange}
                        id=""
                        className="form-select"
                        required
                      >
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                        <option value="prefer not to say">
                          Prefer not to say
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-12 text-center">
                    <button className="thm-btn dark" type="submit">
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>

          {/* <div className="address-section mb-5">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="section-title">My Addresses</h4>
              <button
                className="thm-btn"
                onClick={() => {
                  setSelectedAddress(null);
                  setShowAddressModal(true);
                }}
              >
                Add New Address
              </button>
            </div>

            <div className="row">
              {addresses.map((address) => (
                <div key={address._id} className="col-md-6 mb-4">
                  <div
                    className={`address-card ${
                      address.isDefault ? "default" : ""
                    }`}
                  >
                    <div className="address-card-header">
                      <span className="address-type">{address.type}</span>
                      {address.isDefault && (
                        <span className="default-badge">Default</span>
                      )}
                    </div>
                    <div className="address-card-body">
                      <h5 className="building-name">{address.buildingName}</h5>
                      <p className="street">{address.street}</p>
                      {address.landmark && (
                        <p className="landmark">Near {address.landmark}</p>
                      )}
                      <p className="city-state">{`${address.city}, ${address.state} ${address.postalCode}`}</p>
                      <p className="country">{address.country}</p>
                    </div>
                    <div className="address-card-footer">
                      <button
                        className="thm-btn sm"
                        onClick={() => {
                          setSelectedAddress(address);
                          setShowAddressModal(true);
                        }}
                      >
                        Edit
                      </button>
                      {!address.isDefault && (
                        <button
                          className="thm-btn sm dark"
                          onClick={() => handleSetDefaultAddress(address._id)}
                        >
                          Set as Default
                        </button>
                      )}
                      <button
                        className="thm-btn sm danger"
                        onClick={() => handleDeleteAddress(address._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div> */}

          <div className="address-section mb-5">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="fw-bold text-dark">My Addresses</h4>
              <button
                className="btn px-2"
                style={{ backgroundColor: "#3c3260", color: "white" }}
                onClick={() => {
                  setSelectedAddress(null);
                  setShowAddressModal(true);
                }}
              >
                + Add New Address
              </button>
            </div>

            <div className="row g-4">
              {addresses.map((address) => (
                <div key={address._id} className="col-md-6">
                  <div
                    className={`card shadow-sm border-0 p-3 ${
                      address.isDefault ? "border-primary" : "border-secondary"
                    }`}
                  >
                    {/* Address Type & Default Badge */}
                    <div className="d-flex justify-content-between align-items-center">
                      <span
                        className="p-2 rounded text-white "
                        style={{ backgroundColor: "#3c3260" }}
                      >
                        {address.type}
                      </span>
                      {address.isDefault && (
                        <span className="p-2 rounded text-white bg-success">
                          Default
                        </span>
                      )}
                    </div>

                    {/* Address Details */}
                    <div className="mt-3">
                      <h5 className="fw-semibold text-dark">
                        {address.buildingName}
                      </h5>
                      <p className="mb-1 text-secondary">{address.street}</p>
                      {address.landmark && (
                        <p className="mb-1 text-muted">
                          Near {address.landmark}
                        </p>
                      )}
                      <p className="mb-1 text-secondary">
                        {address.city}, {address.district}, {address.state} -{" "}
                        {address.postalCode}
                      </p>
                      <p className="mb-0 text-muted">{address.country}</p>
                    </div>

                    {/* Buttons */}
                    <div className="mt-3 d-flex gap-2 justify-content-end">
                      <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => {
                          setSelectedAddress(address);
                          setShowAddressModal(true);
                        }}
                      >
                        <i className="fas fa-edit me-1"></i>
                        Edit
                      </button>

                      {!address.isDefault && (
                        <button
                          className="btn btn-outline-dark btn-sm"
                          onClick={() => handleSetDefaultAddress(address._id)}
                        >
                          <i className="fas fa-star me-1"></i>
                          Set as Default
                        </button>
                      )}

                      <button
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => handleDeleteAddress(address._id)}
                      >
                        <i className="fas fa-trash me-1"></i>
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))}

              {/* No addresses message */}
              {addresses.length === 0 && (
                <div className="col-12">
                  <div className="text-center p-4 bg-light rounded">
                    <i className="fas fa-map-marker-alt fa-3x text-muted mb-3"></i>
                    <p className="text-muted">
                      No addresses added yet. Please add your first address.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="text-end mt-3 mb-3">
            <button onClick={handleAccountDelete} className="thm-btn danger">
              Delete Account
            </button>
          </div>
        </div>
      </section>

      <AddressModal
        show={showAddressModal}
        onHide={() => {
          setShowAddressModal(false);
          setSelectedAddress(null);
        }}
        onSubmit={handleAddressSubmit}
        address={selectedAddress}
      />

      <div id="recaptcha-container"></div>
    </>
  );
};

export default Profile;
